export default "__VITE_ASSET__zeJsdLVy__";